<template>
  <div class="">
    <form @submit.prevent.stop="submit()">
      <div class="">
        <section class="">
          <div class="columns">
            <div class="column">
              <label class="label">Date et Heure</label>
              <div class="field has-addons">
                <div class="control is-expanded has-icons-right">
                  <flat-pickr type="date" class="input is-radiusless"
                              v-if="date"
                              :value="date"
                              v-model="date"
                              :config="dtConfig">
                  </flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-square is-radiusless" @click="date = null">
                    <i class="fal fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </form>
  </div>
</template>
<script>
  import moment from 'moment'

  export default {
    name: 'OptionUpdateDateModal',
    props: {
      source: {
        required: true
      }
    },
    data () {
      return {
        realDate: new Date(),
        date: null,
        minDate: null
      }
    },
    computed: {
      dtConfig () {
        return {
          enableTime: true,
          altInput: true,
          altFormat: 'j F Y H:i',
          dateFormat: 'Z',
          time_24hr: true,
          minDate: this.minDate,
          inline: true,
          minuteIncrement: 1
        }
      }
    },
    methods: {
      submit () {
        let hour = document.querySelector('.flatpickr-hour').value
        let minute = document.querySelector('.flatpickr-minute').value
        let newDate = moment(this.date).set({'hour': hour, 'minute': minute})
        this.date = newDate._d
        this.$emit('submit', {option: this.source, date: this.date})
      }
    },
    mounted () {
      if (this.source) {
        this.date = new Date(this.source.end_date)
      } else {
        this.date = new Date()
      }
      this.minDate = new Date(this.date.getTime())
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/quickview/OptionUpdateDateModal.vue